// 항목 리스트를 떠 있는 메뉴로 보여주는 케밥 팝업.
//
// anchor 버튼 위치를 기준으로 below/above 자동 선택, 화면 우측을 안 넘게 left
// 보정. 메뉴 외부 클릭/스크롤/리사이즈에서 dismiss. 한 번에 하나만 떠 있도록
// 모듈 싱글톤으로 관리(다른 케밥을 또 열면 기존 것은 자동 close).

import { Fragment, render } from "preact";

export interface KebabItem {
  label: string;
  danger?: boolean;
  onclick: (e: MouseEvent) => void;
}

let kebabMenuEl: HTMLElement | null = null;
let kebabMenuDocHandler: ((e: Event) => void) | null = null;

export function closeKebabMenu(): void {
  if (kebabMenuEl) {
    render(null, kebabMenuEl);
    kebabMenuEl.remove();
    kebabMenuEl = null;
  }
  if (kebabMenuDocHandler) {
    document.removeEventListener("click", kebabMenuDocHandler, true);
    window.removeEventListener("scroll", kebabMenuDocHandler, true);
    window.removeEventListener("resize", kebabMenuDocHandler, true);
    kebabMenuDocHandler = null;
  }
}

function KebabItems({ items }: { items: KebabItem[] }) {
  return (
    <Fragment>
      {items.map((it, i) => (
        <button
          key={i}
          type="button"
          class={"kebab-menu__item" + (it.danger ? " kebab-menu__item--danger" : "")}
          role="menuitem"
          onClick={it.onclick}
        >
          {it.label}
        </button>
      ))}
    </Fragment>
  );
}

export function openKebabMenu(items: KebabItem[], anchorBtn: HTMLElement): void {
  closeKebabMenu();
  if (items.length === 0) return;

  // 컨테이너 자체가 .kebab-menu 박스가 되도록 직접 render.
  // mountPreact의 display:contents 래퍼는 offsetWidth/Height가 0이라 위치 계산 불가.
  const menu = document.createElement("div");
  menu.className = "kebab-menu";
  menu.setAttribute("role", "menu");
  document.body.append(menu);
  render(<KebabItems items={items} />, menu);

  const rect = anchorBtn.getBoundingClientRect();
  const menuWidth = menu.offsetWidth;
  const menuHeight = menu.offsetHeight;
  let top = rect.bottom + 4;
  if (top + menuHeight > window.innerHeight - 8) top = rect.top - menuHeight - 4;
  let left = rect.right - menuWidth;
  if (left < 8) left = 8;
  menu.style.top = `${top}px`;
  menu.style.left = `${left}px`;
  kebabMenuEl = menu;
  kebabMenuDocHandler = (e: Event) => {
    if (e && e.type === "click" && menu.contains((e as MouseEvent).target as Node)) return;
    closeKebabMenu();
  };
  // setTimeout — 같은 click 이벤트가 곧장 dismiss로 잡히지 않게 다음 tick에 등록.
  setTimeout(() => {
    document.addEventListener("click", kebabMenuDocHandler!, true);
    window.addEventListener("scroll", kebabMenuDocHandler!, true);
    window.addEventListener("resize", kebabMenuDocHandler!, true);
  }, 0);
}
